import { Grid, Typography } from "@material-ui/core";

const PosApiEndpointsListComp = ({ classes }) => {
  const endPoints = [
    {
      key: "Register License API",
      endPoint: `pos/restaurant/license/apikey`,
    },
    {
      key: "Get License Status API",
      endPoint: `pos/restaurant/license/data/apikey?device_id={device_id}`,
    },
    {
      key: "Write POS data API",
      endPoint: `pos/restaurant/license/data`,
    },
    {
      key: "Read POS data API",
      endPoint: `pos/restaurant/license/data/fetch?key={key}`,
    },
  ];
  return (
    <>
      <Grid container direction="row" spacing={5}>
        <Grid item xs={12} className={classes.mt30}>
          <Typography variant="h5" className={classes.typographyStyles}>
            POS Api Endpoints
          </Typography>
          <hr />
          <Grid item xs={12} direction="column">
            {endPoints.map((item, index) => (
              <Typography
                variant="body1"
                key={index}
                className={classes.typographyStyles}
                style={{
                  marginTop: "15px",
                  marginBottom: "5px",
                }}
              >
                {item.key} : {item.endPoint}
              </Typography>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PosApiEndpointsListComp;
